module.exports = __webpack_public_path__ + "img/DE03071.1076b45f.png";